import { render, staticRenderFns } from "./CheckingSendDestinationAgentWindow.vue?vue&type=template&id=f8a5810c&scoped=true&"
import script from "./CheckingSendDestinationAgentWindow.vue?vue&type=script&lang=js&"
export * from "./CheckingSendDestinationAgentWindow.vue?vue&type=script&lang=js&"
import style0 from "./CheckingSendDestinationAgentWindow.vue?vue&type=style&index=0&id=f8a5810c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a5810c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a5810c')) {
      api.createRecord('f8a5810c', component.options)
    } else {
      api.reload('f8a5810c', component.options)
    }
    module.hot.accept("./CheckingSendDestinationAgentWindow.vue?vue&type=template&id=f8a5810c&scoped=true&", function () {
      api.rerender('f8a5810c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/CheckingManager/CheckingSendDestinationAgentWindow.vue"
export default component.exports